<template>
    <div class="gi">

        <!-- ════════════════════ HEADER CARD ════════════════════ -->
        <div class="gi-dash-header">
            <div class="gi-dash-header-top">
                <div>
                    <div class="gi-eyebrow">MARKETING · INFLUENCERS DISCOVERY</div>
                    <h1 class="gi-title">Gestión de influencers</h1>
                </div>
                <div class="gi-header-actions">
                    <div class="gi-stat-pill" v-if="plataformaSeleccionada === 'youtube'">
                        <i class="fa-brands fa-youtube"></i>
                        <strong>{{ listadoFiltrado.length }}</strong>
                        <span>canales</span>
                    </div>
                    <div class="gi-stat-pill" v-else-if="plataformaSeleccionada === 'google'">
                        <i class="fa-brands fa-google"></i>
                        <strong v-if="filtroEstadoGoogle !== 'Editores'">{{ resultadosFiltradosGoogle.length }}</strong>
                        <strong v-else>{{ listaEditores.length }}</strong>
                        <span>{{ filtroEstadoGoogle === 'Editores' ? 'editores' : 'webs' }}</span>
                    </div>
                </div>
            </div>

            <!-- ════ Platform tabs (segmented) ════ -->
            <div class="gi-platforms">
                <button
                    type="button"
                    class="gi-platform"
                    :class="{ 'is-active': plataformaSeleccionada === 'youtube' }"
                    @click="plataformaSeleccionada = 'youtube'"
                >
                    <i class="fa-brands fa-youtube" style="color: #FF0000;"></i>
                    <span>YouTube</span>
                </button>
                <button
                    type="button"
                    class="gi-platform is-disabled"
                    disabled
                >
                    <i class="fa-brands fa-instagram"></i>
                    <span>Instagram</span>
                    <span class="gi-platform-soon">SOON</span>
                </button>
                <button
                    type="button"
                    class="gi-platform"
                    :class="{ 'is-active': plataformaSeleccionada === 'google' }"
                    @click="plataformaSeleccionada = 'google'"
                >
                    <i class="fa-brands fa-google" style="color: #4285F4;"></i>
                    <span>Google</span>
                </button>
                <button
                    type="button"
                    class="gi-platform is-disabled"
                    disabled
                >
                    <i class="fa-brands fa-tiktok"></i>
                    <span>TikTok</span>
                    <span class="gi-platform-soon">SOON</span>
                </button>
            </div>
        </div>

        <b-card-code  v-if="plataformaSeleccionada == 'youtube'">
          <b-row class="match-height">
            <b-col md="4">
              <b-form-group label="Buscador" label-for="unidades">
                <b-form-input id="unidades" type="text" placeholder="Texto a buscar" v-model="texto" />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Filtrar por estado" label-for="filtro-estado">
                <v-select
                  v-model="filtroEstado"
                  :options="['Todos', 'Revisar', 'Favoritos', 'Contactados','Relevantes sin contactar', 'Relevantes, agregar email', 'No Relevantes']"
                  :clearable="false"
                  placeholder="Seleccionar estado"
                  style="width: 100%"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Filtrar por categoria" label-for="filtro-categoria">
                <v-select
                  v-model="categoriaFiltroSeleccionada"
                  :options="categoriasOpcionesFiltro"
                  :clearable="false"
                  placeholder="Seleccionar estado"
                  style="width: 100%"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Filtrar por texto del campo youtube Busqueda" label-for="filtro-youtube-busqueda">
                <b-form-input
                    id="filtro-youtube-busqueda"
                    type="text"
                    placeholder="Texto en youtube Busqueda"
                    v-model="filtroYoutubeBusquedaTexto"
                  />
                </b-form-group>
            </b-col>
          </b-row>
        </b-card-code>

        <div class="gi-yt-wrap" v-if="plataformaSeleccionada == 'youtube'">
          <h3>Total encontrados: <span>{{ listadoFiltrado.length }}</span></h3>
          <div class="gi-grid">
            <article
              v-for="canal in listadoFiltrado"
              :key="canal.canalUrl"
              class="gi-channel"
              :style="fondoPorEmail(canal)"
            >

              <!-- HEAD -->
              <header class="gi-ch-head">
                <a :href="canal.canalUrl + '/videos'" target="_blank" class="gi-ch-avatar-wrap">
                  <img
                    :src="canal.canalFoto"
                    referrerpolicy="no-referrer"
                    class="gi-ch-avatar"
                    alt="Canal"
                  />
                </a>
                <div class="gi-ch-info">
                  <div class="gi-ch-name-row">
                    <a :href="canal.canalUrl + '/videos'" target="_blank" class="gi-ch-name">{{ canal.canalTitulo }}</a>
                    <button
                      class="gi-ch-fav"
                      :class="{ 'is-fav': canal.influencer && canal.influencer.fav == 1 }"
                      @click="changeFav(canal)"
                      :title="canal.influencer && canal.influencer.fav == 1 ? 'Quitar favorito' : 'Marcar favorito'"
                    >
                      <i :class="canal.influencer && canal.influencer.fav == 1 ? 'fa-solid fa-star' : 'fa-regular fa-star'"></i>
                    </button>
                  </div>
                  <div class="gi-ch-meta">
                    <span class="gi-ch-meta-item">
                      <i class="fa-solid fa-location-dot"></i>
                      {{ paisNombre(canal.canalPais) }}
                    </span>
                    <span class="gi-ch-meta-sep">·</span>
                    <span class="gi-ch-meta-item gi-ch-meta-strong">
                      <i class="fa-solid fa-users"></i>
                      {{ formatSubs(canal.canalSubscriptores) }}
                    </span>
                  </div>
                </div>
                <div class="gi-ch-action">
                  <button
                    v-if="canal.influencer == null || canal.influencer.email == ''"
                    class="gi-ch-btn gi-ch-btn--warn"
                    @click="abrirModalEmail(canal)"
                  >
                    <i class="fa-solid fa-envelope-open-text"></i>
                    <span>Añadir email</span>
                  </button>
                  <button
                    v-else
                    class="gi-ch-btn gi-ch-btn--primary"
                    @click="enviarCorreo(canal)"
                  >
                    <i class="fa-solid fa-paper-plane"></i>
                    <span>Contactar</span>
                  </button>
                </div>
              </header>

              <!-- CATEGORIES + STATS -->
              <div class="gi-ch-tags">
                <button class="gi-ch-cat-btn" @click="openCategoriasInfluencer(canal)">
                  <i class="fa-solid fa-tags"></i>
                  <span v-if="canal.influencer && canal.influencer.categoria && canal.influencer.categoria != ''">
                    {{ canal.influencer.categoria.replaceAll('"','') }}
                  </span>
                  <span v-else class="gi-ch-cat-empty">Sin categorías</span>
                </button>
                <span v-if="canal.coincidencias > 1" class="gi-ch-pill gi-ch-pill--match">
                  <i class="fa-solid fa-bullseye"></i>
                  {{ canal.coincidencias }} match{{ canal.coincidencias > 1 ? 'es' : '' }}
                </span>
                <span v-if="canal.influencer && canal.influencer.emailEnviados > 0" class="gi-ch-pill gi-ch-pill--contacted">
                  <i class="fa-solid fa-envelope-circle-check"></i>
                  {{ canal.influencer.fechaUltimoEmail }} · {{ canal.influencer.emailEnviados }}
                </span>
              </div>

              <!-- VIDEOS -->
              <ul class="gi-ch-videos">
                <li
                  v-for="video in (mostrarTodos[canal.canalUrl] ? canal.videos : canal.videos.slice(0, 3))"
                  :key="video.videoId"
                  class="gi-ch-video"
                >
                  <a :href="'https://www.youtube.com/watch?v=' + video.videoId" target="_blank" class="gi-ch-video-thumb">
                    <img :src="video.videoFoto" :alt="video.videoTitulo" />
                    <span class="gi-ch-video-play"><i class="fa-solid fa-play"></i></span>
                  </a>
                  <div class="gi-ch-video-body">
                    <a :href="'https://www.youtube.com/watch?v=' + video.videoId" target="_blank" class="gi-ch-video-title">
                      {{ video.videoTitulo }}
                    </a>
                    <div class="gi-ch-video-stats">
                      <span><i class="fa-solid fa-eye"></i> {{ formatViews(video.videoVisitas) }}</span>
                      <span class="gi-ch-meta-sep">·</span>
                      <span><i class="fa-regular fa-clock"></i> {{ formatFecha(video.videoFecha) }}</span>
                    </div>
                    <div class="gi-ch-video-search">
                      <span class="gi-ch-tag">{{ video.youtubeBusqueda.texto }}</span>
                      <span v-if="video.youtubeBusqueda.idioma" class="gi-ch-tag gi-ch-tag--mini">{{ video.youtubeBusqueda.idioma }}</span>
                      <span v-if="video.youtubeBusqueda.pais" class="gi-ch-tag gi-ch-tag--mini">{{ video.youtubeBusqueda.pais }}</span>
                    </div>
                  </div>
                </li>
              </ul>

              <button
                v-if="canal.videos.length > 3"
                class="gi-ch-more"
                @click="toggleMostrarTodos(canal.canalUrl)"
              >
                <i :class="mostrarTodos[canal.canalUrl] ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
                <span>{{ mostrarTodos[canal.canalUrl] ? 'Mostrar menos' : 'Ver ' + (canal.videos.length - 3) + ' más' }}</span>
              </button>

              <!-- FOOTER ACTIONS -->
              <footer class="gi-ch-foot" v-if="checkBotonRelevante(canal) || checkBotonNoRelevante(canal)">
                <button
                  v-if="checkBotonRelevante(canal)"
                  class="gi-ch-btn gi-ch-btn--success"
                  @click="relevante(canal)"
                >
                  <i class="fa-solid fa-check"></i>
                  <span>Relevante</span>
                </button>
                <button
                  v-if="checkBotonNoRelevante(canal)"
                  class="gi-ch-btn gi-ch-btn--ghost-danger"
                  @click="noRelevante(canal)"
                >
                  <i class="fa-solid fa-xmark"></i>
                  <span>No relevante</span>
                </button>
              </footer>
            </article>
          </div>
        </div>

        <b-card-code v-if="plataformaSeleccionada == 'google'">
          <b-row class="match-height">
            <b-col md="4">
              <b-form-group label="Buscar por texto" label-for="busqueda-texto">
                <b-form-input id="busqueda-texto" v-model="textoBusquedaGoogle" placeholder="Ej. moda, salud..." />
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="Filtrar por estado" label-for="filtro-estado">
                <v-select
                  v-model="filtroEstadoGoogle"
                  :options="['Todos', 'Revisar', 'No relevantes','Relevantes','Editores']"
                  :clearable="false"
                  placeholder="Seleccionar estado"
                  style="width: 100%"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Filtrar por DR" label-for="filtro-estado">
                <v-select
                  v-model="filtroDRGoogle"
                  :options="['Todos','90 >', '75 - 89', '50 - 74','< 49']"
                  :clearable="false"
                  placeholder="Seleccionar estado"
                  style="width: 100%"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Filtrar por texto del campo google Busqueda" label-for="filtro-google-busqueda">
                <b-form-input
                    id="filtro-google-busqueda"
                    type="text"
                    placeholder="Texto en google Busqueda"
                    v-model="filtroGoogleBusquedaTexto"
                  />
                </b-form-group>
            </b-col>
            
          </b-row>
        </b-card-code>

        <b-container fluid v-if="plataformaSeleccionada == 'google'">
          <h3>Total encontrados: <span v-if="filtroEstadoGoogle !== 'Editores'">{{ resultadosFiltradosGoogle.length }}</span>  <span v-else> {{ listaEditores.length }}</span> </h3>

          <!-- Agrupar resultados por displayLink -->
          <b-row v-if="filtroEstadoGoogle !== 'Editores'">
            <b-col
              v-for="(grupo, displayLink) in agruparPorDisplayLink(resultadosFiltradosGoogle)"
              :key="displayLink"
              md="4"
              class="mb-4"
              v-if="debeMostrarGrupo(grupo, displayLink)"
            >
              <b-card class="p-2">

                <b-col class="d-flex align-items-center">
                  <!-- Imagen a la izquierda -->
                  <img 
                    :src="'https://' + displayLink + '/favicon.ico'" 
                    alt="Favicon" 
                    width="20" 
                    height="20" 
                    class="mr-2"
                  />
                  <!-- Texto a la derecha -->
                  <div>
                    <h6><a :href="'https://' + displayLink" target="_blank">{{ displayLink }}</a></h6>
                    <p class="mb-1">
                      <strong>DR:</strong>
                      <span :style="{ color: getColorByDR(grupo[0].dr) }">{{ grupo[0].dr }}</span> |
                      <strong>Tráfico:</strong> {{ grupo[0].traffic }}
                    </p>
                  </div>
                </b-col>

                <b-row class="mb-2">
                    <b-col cols="4" class="text-left">
                      <b-button
                       v-if="grupo[0].estadoWeb == 0 || grupo[0].estadoWeb == 2"
                        size="sm"
                        variant="success"
                        @click="estadoGoogleWeb(grupo[0], 1)"
                      >
                        Relevante
                      </b-button>
                    </b-col>
                    <b-col cols="4" class="text-right">
                    </b-col>
                    <b-col cols="4" class="text-right">
                      <b-button
                      v-if="grupo[0].estadoWeb == 0 || grupo[0].estadoWeb == 1"
                        size="sm"
                        variant="danger"
                        @click="estadoGoogleWeb(grupo[0], 2)"
                      >
                        No relevante
                      </b-button>
                    </b-col>
                  </b-row>
            
                <!-- Resultados dentro de cada grupo -->
                <div v-for="(resultado, index) in grupo.filter(r => 
                    filtroEstadoGoogle === 'Todos' ||
                    (filtroEstadoGoogle === 'Relevantes' && r.estadoResultado === 1) ||
                    (filtroEstadoGoogle === 'No relevantes' && r.estadoResultado === 2) ||
                    (filtroEstadoGoogle === 'Revisar' && r.estadoResultado === 0)
                  ).slice(0, mostrarTodosGoogle[displayLink] ? grupo.length : 3)"  :key="resultado.id">
                  <b-row class="align-items-center">
                    <!-- Imagen pequeña a la izquierda -->
                    <b-col cols="2" class="pr-2">
                      <b-img
                        v-if="resultado.imagen"
                        :src="resultado.imagen"
                        fluid
                        alt="Imagen del resultado"
                        class="img-thumbnail"
                        style="max-width: 60px; max-height: 60px; object-fit: cover;"
                      />
                    </b-col>
                    <b-col cols="10">
                      <h6>
                        <a :href="resultado.enlace" target="_blank">{{ resultado.titulo }}</a>
                      </h6>
                    </b-col>                

                    <b-col cols="12">
                      <p style="margin-bottom: 0px;">{{ resultado.descripcion }}</p>
                    </b-col>

                  </b-row>

                <b-row>


                    <!-- Título y detalles en la misma línea -->
                    <b-col cols="12">
                      
                      <small class="text-muted">
                        <strong>Búsqueda:</strong> {{ resultado.textoBusqueda }}
                        
                        <!-- Solo mostrar Idioma si no está vacío -->
                        <span v-if="resultado.idioma">
                          | <strong>Idioma:</strong> {{ resultado.idioma }}
                        </span>

                        <!-- Solo mostrar País si no está vacío -->
                        <span v-if="resultado.pais">
                          | <strong>País:</strong> {{ resultado.pais }}
                        </span>
                      </small>
                      <small class="text-muted d-block">
                        <strong>Encontrado:</strong> {{ resultado.fechaEncontrado.split('T')[0] }}
                      </small>
                    </b-col>
                    
                  </b-row>

                  <b-row class="mb-2">
                    <b-col cols="4" class="text-left">
                      <b-button
                        v-if="resultado.estadoResultado == 0 || resultado.estadoResultado == 2"
                        size="sm"
                        variant="success"
                        @click="estadoGoogleEnlace(resultado, 1)"
                      >
                        Relevante
                      </b-button>
                        <b-button
                        v-else
                        size="sm"
                        :variant="buscarEditoresArticulo(resultado) !== '' ? 'success' : 'primary'"
                        @click="vincularEditor(resultado)"
                        >
                        <i 
                        class="fa-solid fa-user-plus"                         
                        ></i> Add Editor {{ buscarEditoresArticulo(resultado) }}
                      </b-button>
                      <!--<i v-else class="fa-solid fa-user-plus btn-font-circle" style="margin-top: 10px;"></i>-->
                    </b-col>
                    <b-col cols="4" class="text-right">
                    </b-col>
                    <b-col cols="4" class="text-right">
                      <b-button
                       v-if="resultado.estadoResultado == 0 || resultado.estadoResultado == 1"
                        size="sm"
                        variant="danger"
                        @click="estadoGoogleEnlace(resultado, 2)"
                      >
                        No relevante
                      </b-button>
                    </b-col>
                  </b-row>
                </div>

                
                
                <!-- Mostrar más si hay más de 3 resultados en el grupo -->
                <b-row>
                  <b-col cols="12" class="text-center">
                    <button
                      v-if="grupo.filter(r =>
                        filtroEstadoGoogle === 'Todos' ||
                        (filtroEstadoGoogle === 'Relevantes' && r.estadoResultado === 1) ||
                        (filtroEstadoGoogle === 'No relevantes' && r.estadoResultado === 2) ||
                        (filtroEstadoGoogle === 'Revisar' && r.estadoResultado === 0)
                      ).length > 3"
                      class="btn btn-link p-0"
                      @click="toggleMostrarTodosGoogle(displayLink)"
                    >
                      {{ mostrarTodosGoogle[displayLink] ? 'Mostrar menos -' : 'Mostrar más +' + (
                        grupo.filter(r =>
                          filtroEstadoGoogle === 'Relevantes' && r.estadoResultado === 1 ||
                          filtroEstadoGoogle === 'No relevantes' && r.estadoResultado === 2 ||
                          filtroEstadoGoogle === 'Revisar' && r.estadoResultado === 0
                        ).length - 3) }}
                    </button>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <div v-else> <!-- EDITORES -->
            <b-row>
              <b-col>
                <div style="font-size: 40px;" v-if="false">
                    <span 
                    @click="googleEditoresTipoVista = 'lista'" 
                    class="span-btn" 
                    :style="{ marginRight: '10px', color: googleEditoresTipoVista === 'lista' ? '#5ba8fa' : 'inherit' }"
                    >
                    <i class="fa-solid fa-list"></i>
                    </span>
                    <span 
                    @click="googleEditoresTipoVista = 'card'" 
                    class="span-btn" 
                    :style="{ color: googleEditoresTipoVista === 'card' ? '#5ba8fa' : 'inherit' }"
                    >
                    <i class="fa-solid fa-table-cells"></i>
                    </span>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="googleEditoresTipoVista == 'card'">
              <b-col
                
                v-for="item in listaEditores"
                :key="item.id"
                md="4"
                class="mb-4"
              >
                <b-card class="p-2">

                  <b-row>
                    <b-col cols="9" class="" style="padding-left: 0px;">                  
                      <!-- Texto a la derecha -->
                      <div>
                        <h3>{{ item.nombre }}</h3>
                        <h6>{{ item.email }}</h6>
                        <h6>Categorias: {{ item.categorias.replaceAll('"','') }}</h6>
                      
                      </div>
                    </b-col>

                    <b-col cols="3" class="text-right">
                        <b-button
                            size="sm"
                            variant="primary"
                            @click="enviarCorreo('')"
                          >
                            Contactar
                        </b-button>
                    </b-col>

                    <b-col cols="12" class="text-left" style="padding-left: 0px; margin-bottom: 20px;">
                      <small class="text-muted">
                            <strong>Fecha encontrado:</strong> {{ formatFechaLarga(item.fechaEncontrado) }} <br>
                            <strong>Articulos:</strong> {{ item.enlaces.length }} |
                            <strong>Medios:</strong> {{ item.url.length }} |
                          </small>
                          <small class="text-muted">
                            <strong>Mejor DR:</strong> 87 |
                            <strong>Traffic:</strong> 101M <br>
                          </small>
                          <small v-if="item.emailEnviados > 0">
                            <br>
                            <b>Ultimo contacto: {{ formatFechaLarga(item.fechaUltimoEmail) }}</b>
                            <br>
                            {{ item.emailEnviados }} email{{ item.emailEnviados > 1 ? 's' : '' }} enviados
                          </small>
                    </b-col>
                  </b-row>

                  <b-row class="mb-2" v-if="false">
                      <b-col cols="4" class="text-left">
                        <b-button
                          size="sm"
                          variant="success"
                        >
                          Relevante
                        </b-button>
                      </b-col>
                      <b-col cols="4" class="text-right">
                      </b-col>
                      <b-col cols="4" class="text-right">
                        <b-button
                          size="sm"
                          variant="danger"
                        >
                          No relevante
                        </b-button>
                      </b-col>
                  </b-row>
              
                  <!-- Resultados dentro de cada grupo -->
                  <div v-for="(resultado, index) in item.enlaces"  :key="resultado.id" class="mb-1">
                    <b-row class="align-items-center">
                      <!-- Imagen pequeña a la izquierda -->
                      <b-col cols="2" class="pr-2">
                        <b-img
                          v-if="resultado.imagen"
                          :src="resultado.imagen"
                          fluid
                          alt="Imagen del resultado"
                          class="img-thumbnail"
                          style="max-width: 60px; max-height: 60px; object-fit: cover;"
                        />
                      </b-col>
                      <b-col cols="10">
                        <h6>
                          <a :href="resultado.enlace" target="_blank">{{ resultado.titulo }}</a>
                        </h6>
                      </b-col>                

                      <b-col cols="12">
                        <p style="margin-bottom: 0px;">{{ resultado.descripcion }}</p>
                      </b-col>

                    </b-row>

                    <b-row>

                      <!-- Título y detalles en la misma línea -->
                      <b-col cols="12">
                        
                        <small class="text-muted">
                          <strong>Búsqueda:</strong> {{ resultado.textoBusqueda }}
                          
                          <!-- Solo mostrar Idioma si no está vacío -->
                          <span v-if="resultado.idioma">
                            | <strong>Idioma:</strong> {{ resultado.idioma }}
                          </span>

                          <!-- Solo mostrar País si no está vacío -->
                          <span v-if="resultado.pais">
                            | <strong>País:</strong> {{ resultado.pais }}
                          </span>
                        </small>
                        <small class="text-muted d-block">
                          <strong>Encontrado:</strong> {{ resultado.fechaEncontrado.split('T')[0] }}
                        </small>
                      </b-col>
                      
                    </b-row>
                  </div>

                  
                  
                
                </b-card>
              </b-col>
            </b-row>
            <b-row v-if="googleEditoresTipoVista == 'lista'">
              <b-card style="width: 100%;">
                <b-table
                  :items="listaEditores"
                  :fields="[
                    { key: 'nombre', label: 'Nombre' },
                    { key: 'email', label: 'Email' },
                    { key: 'categorias', label: 'Categorías' },
                    { key: 'fechaEncontrado', label: 'Fecha encontrado' },
                    { key: 'articulos', label: 'Articulos' },                    
                    { key: 'medios', label: 'Medios' },
                    { key: 'drtraffic', label: 'DR-Traffic' },
                    { key: 'emailEnviados', label: 'Emails enviados' },
                    { key: 'acciones', label: 'Acciones' }
                  ]"
                  responsive
                  striped
                  hover
                  small
                >
                  <template #cell(categorias)="data">
                    {{ data.item.categorias.replaceAll('"', '') }}
                  </template>

                  <template #cell(fechaEncontrado)="data">
                    {{ formatFechaLarga(data.item.fechaEncontrado) }}
                  </template>

                  <template #cell(drtraffic)="data">
                    {{ data.item.mejorDr }} | {{ data.item.traffic }}
                  </template>

                  <template #cell(medios)="data">
                    {{ data.item.medios }}
                  </template>

                  <template #cell(articulos)="data">
                    {{ data.item.enlaces.length }}
                  </template>                

                  <template #cell(emailEnviados)="data">
                    <div>
                      <span>{{ data.item.emailEnviados }}</span>
                      <div v-if="data.item.emailEnviados > 0">
                        <small><strong>Último:</strong> {{ formatFechaLarga(data.item.fechaUltimoEmail) }}</small>
                      </div>
                    </div>
                  </template>

                  <template #cell(acciones)="data">
                    <!--<b-button size="sm" variant="primary" @click="enviarCorreo(data.item.email)">Contactar</b-button>-->
                  </template>
            
                </b-table>
              </b-card>

            </b-row>
          </div>
        </b-container>

  <b-modal
        id="modal-email"
        title="Contactar"
        centered
        size="xl"
        hide-footer
        >             
        <div>
          <b-row>

            <b-col md="3">
              <b-list-group>
                        <b-list-group-item
                            v-for="(plantilla, index) in plantillas"
                            :key="index"
                            class="d-flex justify-content-between align-items-center group-item-email"
                            @click="selectPlantilla(plantilla)"
                        >
                        <div class="d-flex align-items-center justify-content-between w-100">
                          <span class="me-2">{{ plantilla.nombre }}</span>
                          </div>
                        </b-list-group-item>
                    </b-list-group>

            </b-col>
            <b-col md="9">
              <h3>Asunto</h3>
              <b-row>
                <b-col md="8">
                    <b-form-input id="unidades" type="text" placeholder="Asunto email" v-model="asunto" />
                </b-col>
                <b-col cols="4" class="d-flex align-items-center" v-if="canalActual != null">
                    <img
                      :src="canalActual.canalFoto"
                      referrerpolicy="no-referrer"
                      class="rounded-circle mr-3"
                      width="48"
                      height="48"
                      alt="Canal"
                    />
                    <div>
                      <h5 class="mb-0">
                        <a :href="canalActual.canalUrl" target="_blank">{{ canalActual.canalTitulo }}</a>
                      </h5>
                      <small>
                        {{ canalActual.influencer.email }}<br />
                        {{ paisNombre(canalActual.canalPais) }}<br />
                        {{ canalActual.canalSubscriptores.toLocaleString() }} suscriptores
                      </small>
                    </div>
                </b-col>
              </b-row>
                    <br>
                    <h3>Email</h3>
              <quill-editor
                v-model="content"
                :options="editorOption"
                ref="quillEditor"
              />
              <b-button variant="primary" class="mt-3" @click="enviarEmail">
                Enviar Email
              </b-button>
            </b-col>

           

          </b-row>
          
        </div>
      
  </b-modal>

  <b-modal
    id="modal-email-agregar"
    title="Agregar Email"
    @ok="guardarEmail"
    ok-title="Guardar"
    cancel-title="Cancelar"
    centered
  >
    <b-form-group label="Email del influencer:">
      <b-form-input
        v-model="emailTemporal"
        type="email"
        placeholder="correo@ejemplo.com"
        required
      ></b-form-input>
    </b-form-group>
  </b-modal>

  <b-modal
      id="modal-editor-agregar"
      title="Vincular Editor"
      centered
      size="xl"
      hide-footer
      >
      <div>
      <b-row>
          <b-col md="6">
          <h5>Lista de Editores</h5>
          <b-form-group label="Buscar Editor">
            <b-form-input
            v-model="busquedaEditor"
            placeholder="Buscar por nombre, email o categoría"
            />
          </b-form-group>
          <b-list-group>
            <b-list-group-item
              v-for="(editor, index) in listaEditores.filter(editor => 
              !busquedaEditor || 
              editor.nombre.toLowerCase().includes(busquedaEditor.toLowerCase()) || 
              editor.email.toLowerCase().includes(busquedaEditor.toLowerCase()) || 
              editor.categorias.toLowerCase().includes(busquedaEditor.toLowerCase())
              )"
            :key="index"
            class="d-flex justify-content-between align-items-center"
            >
            <span>{{ editor.nombre }} | {{ editor.email }} | {{ editor.categorias.replaceAll('"','') }}| {{ editor.medios}}</span>
            <b-button size="sm" variant="success" @click="selectEditor(editor)">
              Seleccionar
            </b-button>
            </b-list-group-item>
          </b-list-group>
          </b-col>
        <b-col md="6">
          <h5>Agregar Nuevo Editor</h5>
          <b-form>
            <b-form-group label="Nombre del Editor">
            <b-form-input v-model="nuevoEditor.nombre" placeholder="Nombre del editor" required />
            </b-form-group>
            <b-form-group label="Email del Editor">
            <b-form-input v-model="nuevoEditor.email" type="email" placeholder="Email del editor" required />
            </b-form-group>
            <b-form-group label="País">
            <b-form-input v-model="nuevoEditor.pais" placeholder="País del editor" />
            </b-form-group>
            <b-form-group label="Categorías">
              <b-form-checkbox-group v-model="nuevoEditor.categorias" :options="categoriasOpciones" stacked></b-form-checkbox-group>
            </b-form-group>
            <b-form-group label="Observaciones">
            <b-form-textarea v-model="nuevoEditor.observaciones" placeholder="Observaciones sobre el editor" rows="3" />
            </b-form-group>
            <b-button @click="addEditor()" variant="success">Agregar</b-button>
          </b-form>
        </b-col>
      </b-row>

      </div>

  </b-modal>

  <b-modal
    id="modal-categoria"
    title="Agregar Categorias"
    @ok="guardarCategoriasInfluencer"
    ok-title="Guardar"
    cancel-title="Cancelar"
    centered
    size="sm"
  >
    <b-form-group label="Categorías">
      <b-form-checkbox-group v-model="categoriasInfluencerSelect" :options="categoriasOpciones" stacked></b-form-checkbox-group>
    </b-form-group>
  </b-modal>


    </div>
  </template>

  <script>
    import axios from '@axios'
    import vSelect from 'vue-select'
    import BCardCode from '@core/components/b-card-code'
    import { BRow, BCol, BFormFile, BButton  } from 'bootstrap-vue'
    import { BTable } from 'bootstrap-vue'
    
    import paises from '../../libs/paisesYoutube';
    import idiomas from '../../libs/idiomasYoutube';

    import { quillEditor } from 'vue-quill-editor'
    
    export default {
    
      components: {
            BCardCode,
            BRow,
            BCol,
            BFormFile,
            BButton,
            vSelect,
            BTable,
            quillEditor,
        },
      data(){
        return{
          plataformaSeleccionada: "youtube",
          texto: "",
          listadoInflucencersYoutube: [],
          editorOption: {
            theme: 'snow',
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                            ['blockquote', 'code-block'],
                            ['link', 'imageUrl', 'video', 'formula'],

                            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
                            [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
                            [{ 'direction': 'rtl' }],                         // text direction

                            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                            [{ 'font': [] }],
                            [{ 'align': [] }],

                            ['clean'],
                        ],
                        imageResize: true,
                        handlers: {
                            'imageUrl': function() {
                                const url = prompt('Introduce la URL de la imagen');

                                if (url) {
                                const range = this.quill.getSelection(); // Obtener la selección actual

                                // Insertar la imagen con insertEmbed
                                this.quill.insertEmbed(range.index, 'image', url);

                                // Obtener el último nodo insertado, que debería ser la imagen
                                const imageElement = this.quill.root.querySelector(`img[src="${url}"]`);
                                
                                if (imageElement) {
                                    // Aplicar el estilo directamente al nodo de la imagen
                                    imageElement.style.maxWidth = "500px";
                                }
                                }
                            }
                        }



                    },
             }
         },
          content: ``,
          plantillas: [],
          maxWidthImg: "500px",
          allInfluencers: [],
          emailTemporal: '',
          canalActual: null,
          asunto: '',
          mostrarTodos: {},
          filtroEstado: "Revisar",
          listaBusquedasYoutube: [],
          allGoogleResultados: [],
          textoBusquedaGoogle: "",
          mostrarTodosGoogle: {}, 
          filtroEstadoGoogle: "Revisar",
          filtroDRGoogle: "Todos",
          nuevoEditor: {
            nombre: '',
            email: '',
            pais: '',
            url: '',
            fechaEncontrado: '',
            emailEnviados: 0,
            fechaUltimoEmail: '',
            categorias: '',
            observaciones: '',
            categorias: []
          },
          listaEditores: [],
          categoriasOpciones: [
            { text: 'Wallets', value: 'Wallets' },
            { text: 'Sleeves', value: 'Sleeves' },
            { text: 'Bags', value: 'Bags' },
            { text: 'Accessories', value: 'Accessories' },
            { text: 'Gifts', value: 'Gifts' }
          ],
          googleEnlaceAddEditor: null,
          busquedaEditor: '',
          googleEditoresTipoVista: 'lista',
          categoriasInfluencerSelect: [],
          canalActualCategoria: null,
          categoriasOpcionesFiltro: [
            'Todas',
            'Wallets',
            'Sleeves' ,
            'Bags' ,
            'Accessories' ,
            'Gifts' 
          ],
          categoriaFiltroSeleccionada: "Todas",
          filtroYoutubeBusquedaTexto: '',
          filtroGoogleBusquedaTexto: ''
        }
      },
      methods:{
        formatSubs(n) {
          n = Number(n) || 0;
          if (n >= 1e9) return (n / 1e9).toFixed(1).replace(/\.0$/, '') + 'B subs';
          if (n >= 1e6) return (n / 1e6).toFixed(1).replace(/\.0$/, '') + 'M subs';
          if (n >= 1e3) return (n / 1e3).toFixed(1).replace(/\.0$/, '') + 'K subs';
          return n + ' subs';
        },
        formatViews(n) {
          n = Number(n) || 0;
          if (n >= 1e9) return (n / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
          if (n >= 1e6) return (n / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
          if (n >= 1e3) return (n / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
          return n.toString();
        },
        toggleMostrarTodosGoogle(displayLink) {
          this.$set(this.mostrarTodosGoogle, displayLink, !this.mostrarTodosGoogle[displayLink]);
        },
        agruparPorDisplayLink(resultados) {
          return resultados.reduce((grupo, resultado) => {
            const displayLink = resultado.displayLink;
            if (!grupo[displayLink]) {
              grupo[displayLink] = [];
            }
            grupo[displayLink].push(resultado);
            return grupo;
          }, {});
        },
        toggleMostrarTodos(canalUrl) {
          this.$set(this.mostrarTodos, canalUrl, !this.mostrarTodos[canalUrl]);
        },
        formatFecha(fecha) {
          return new Date(fecha).toLocaleDateString();
        },
        formatFechaLarga(fecha) {
          // Reemplazamos la parte final (zona horaria con nombre) que rompe el parser
          const cleaned = fecha?.toString().replace(/\s\(.*\)$/, '');
          const parsed = new Date(cleaned);
          return isNaN(parsed) ? 'Fecha inválida' : parsed.toLocaleDateString();
        },
        paisNombre(code) {
          const match = paises.find(p => p.code === code);
          return match ? match.name : code;
        },
        fondoPorEmail(canal) {
          if (!canal.influencer) return '';

          let enviados = canal.influencer.emailEnviados || 0;

          let color = '#ffffff';
          
          if (enviados === 1) color = '#e8f5e9';
          else if (enviados === 2) color = '#c8e6c9';
          else if (enviados === 3) color = '#a5d6a7';
          else if (enviados === 4) color = '#81c784';
          else if (enviados === 5) color = '#66bb6a';
          else if (enviados >= 6) color = '#43a047';

          return {
            backgroundColor: color
          };
        },
        async loadItems(){
          axios.post("/uso", {seccion:"gestion-influencers"});

          const responseReportes = await axios.get("/seo/youtube/influencers");
          const data = responseReportes.data;

          const responsePlantillas = await axios.get("/seo/plantillas");
          this.plantillas = responsePlantillas.data;

          const responseInfluencers = await axios.get("/seo/influencers");
          this.allInfluencers = responseInfluencers.data;

          const agrupados = {};

          data.forEach((item) => {
            const key = item.canalUrl;

            if (!agrupados[key]) {
              agrupados[key] = {
                canalTitulo: item.canalTitulo,
                canalUrl: item.canalUrl,
                canalFoto: item.canalFoto,
                canalPais: item.canalPais,
                canalSubscriptores: item.canalSubscriptores,
                videos: [],
                coincidenciasSet: new Set(), // usamos esto para contar sin duplicados
                coincidencias: 0
              };
            }

            const yaExiste = agrupados[key].videos.some(v => v.videoId === item.videoId);

            if (!yaExiste) {
              agrupados[key].videos.push({
                videoId: item.videoId,
                videoTitulo: item.videoTitulo,
                videoFoto: item.videoFoto,
                videoFecha: item.videoFecha,
                videoVisitas: item.videoVisitas,
                fechaEncontrado: item.fechaEncontrado,
                youtubeBusqueda: item.youtubeBusqueda
              });

              const claveBusqueda = JSON.stringify(item.youtubeBusqueda);
              agrupados[key].coincidenciasSet.add(claveBusqueda);
            }
          });

          for (const key in agrupados) {
              agrupados[key].coincidencias = agrupados[key].coincidenciasSet.size;
              delete agrupados[key].coincidenciasSet;
            }

          this.listadoInflucencersYoutube = Object.values(agrupados)
          .filter(canal => canal.canalSubscriptores >= 1000)
          .map(canal => {
            // Buscar el influencer correspondiente en allInfluencers
            const influencerMatch = this.allInfluencers.find(influencer =>
              influencer.plataformaUrl === canal.canalUrl
            );
            return {
              ...canal,
              influencer: influencerMatch || null // en caso de que no haya match
            };
          })
          .sort((a, b) => b.canalSubscriptores - a.canalSubscriptores);

          const responseGoogleResultados = await axios.get("/seo/google/resultados");
          this.allGoogleResultados = responseGoogleResultados.data.sort((a, b) => {
            const drA = parseInt(a.dr) || 0;
            const drB = parseInt(b.dr) || 0;
            return drB - drA; // Orden descendente
          });          

          const responseGoogleEditoresResultados = await axios.get("/seo/google/editores");

          this.listaEditores = responseGoogleEditoresResultados.data;

            this.listaEditores.forEach(editor => {
            editor.enlaces = [];
            editor.medios = [];
            editor.mejorDr = 0;
            editor.traffic = 0;

            editor.url.forEach(url => {
              const resultado = this.allGoogleResultados.find(resultado => resultado.idResultado == url);
              if (resultado) {
                editor.enlaces.push(resultado);
                let displayLink = resultado.displayLink.replace(/^www\./, ''); // Remove 'www.'
                if (!editor.medios.includes(displayLink)) {
                  editor.medios.push(displayLink);
                }
                if (parseInt(resultado.dr) > editor.mejorDr) {
                  editor.mejorDr = parseInt(resultado.dr);
                  editor.traffic = resultado.traffic;
                }
              }
            });

            editor.medios = editor.medios.join(', ');
          });
        },
        crearYoutube(){
          let info = {
            texto: this.texto,
            pais: this.paisSelected?.code || '',
            idioma: this.idiomaSelected?.code || '',
            relevante: this.relevanteSelected?.code || 'Relevante',
            frecuencia: this.frecuenciaSelected?.code || 'Diaria'
          };
  
            axios
              .post("/seo/youtube/busqueda", info)
              .then(response => {
                  return response.data;
              })
              .then(res => {
                info.id = res.insertId;
                this.listaBusquedasYoutube.push(info);
              });
        },
        enviarCorreo(item){
          this.$bvModal.show('modal-email');

          this.canalActual = item;
          
        },
        lanzarBusqueda(item){

          this.$bvModal.show('modal-youtube');

          return;
          let info = {busquedaid: item.id, texto: item.texto, pais: item.pais, idioma: item.idioma, relevante: item.relevante}

          axios
              .post("/seo/youtube/buscar", info)
              .then(response => {
                  return response.data;
              })
              .then(res => {
                console.log(res);
                this.pruebaDatosYoutube = res;
  
                this.$bvModal.show('modal-youtube');
              });
        },
        borrarBusqueda(item){
          axios
              .delete("/seo/youtube/busqueda/"+item.id)
              .then(response => {
                  return response.data;
              })
              .then(res => {              
                this.listaBusquedasYoutube = this.listaBusquedasYoutube.filter(data => data.id != item.id);
              });
        },
        async guardarPlantilla() {
          if (!this.content || this.content.trim() === '<p><br></p>') {
            this.$bvToast.toast('La plantilla está vacía.', {
              title: 'Error',
              variant: 'danger',
              solid: true
            });
            return;
          }


          try {
            await axios.post('/api/plantillas', {
              nombre: this.nombrePlantilla || 'Plantilla sin título',
              html: this.content
            });

            this.$bvToast.toast('Plantilla guardada con éxito', {
              title: 'Éxito',
              variant: 'success',
              solid: true
            });

            this.$bvModal.hide('modal-email');
            this.content = ''; // limpiar después de guardar

          } catch (error) {
            console.error('Error al guardar la plantilla:', error);
            this.$bvToast.toast('Error al guardar la plantilla', {
              title: 'Error',
              variant: 'danger',
              solid: true
            });
          }
        },
        selectPlantilla(plantilla) {
            this.plantillaSelect = plantilla;
            this.content = plantilla.contenido;
            this.asunto = plantilla.asunto;

            setTimeout(() => {
                const images = this.$refs.quillEditor.$el.querySelectorAll('img');
                images.forEach(img => {
                    img.style.maxWidth = this.maxWidthImg;
                });
            }, 10);
            
        },
        abrirModalEmail(canal) {
          this.canalActual = canal;

          if (!canal.influencer) {
            canal.influencer = {
              nombre: canal.canalTitulo || '',
              plataforma: 'youtube',
              plataformaUrl: canal.canalUrl,
              email: '',
              emailEnviados: 0,
              fechaUltimoEmail: '',
              visible: 1
            };
          }

          this.emailTemporal = canal.influencer.email || '';
          this.$bvModal.show('modal-email-agregar');
        },
        async guardarEmail() {
          if (!this.canalActual || !this.emailTemporal) return;

          const influencer = this.canalActual.influencer;
          influencer.email = this.emailTemporal;
          //influencer.fechaUltimoEmail = new Date().toISOString().slice(0, 10); // formato YYYY-MM-DD

          try {
            if (!influencer.id) {
              const response = await axios.post('/seo/influencers', influencer);
              this.canalActual.influencer = response.data; // en caso de que el backend devuelva el nuevo influencer con ID
              this.$bvToast.toast('Influencer creado con email', {
                variant: 'success',
                solid: true
              });
            } else {
              await axios.post('/seo/influencers/update-email', {
                id: influencer.id,
                email: influencer.email,
                fechaUltimoEmail: influencer.fechaUltimoEmail
              });
              this.$bvToast.toast('Email actualizado', {
                variant: 'success',
                solid: true
              });
            }
          } catch (error) {
            console.error(error);
            this.$bvToast.toast('Error al guardar el email', {
              variant: 'danger',
              solid: true
            });
          }

          // Limpiar estado temporal
          this.canalActual = null;
          this.emailTemporal = '';
        },
        enviarEmail(){

          let contenidoConEstilos = this.content;

          // Crear un elemento temporal para manipular el HTML
          let tempDiv = document.createElement('div');
          tempDiv.innerHTML = contenidoConEstilos;

          // Buscar todas las imágenes dentro del contenido
          let images = tempDiv.querySelectorAll('img');

          // Añadir el estilo max-width a todas las imágenes
          images.forEach(img => {
              img.style.maxWidth = this.maxWidthImg;
          });

          // Actualizar el contenido con las imágenes modificadas
          contenidoConEstilos = tempDiv.innerHTML;

          let info = {
            html: contenidoConEstilos,
            influencer: this.canalActual.influencer,
            asunto: this.asunto
          }

          axios
              .post("/seo/influencers/enviarEmail", info)
              .then(response => {
                  return response.data;
              })
              .then(res => {
                this.$bvToast.toast('Email enviado correctamente', {
                  variant: 'success',
                  solid: true
                });
                this.$bvModal.hide('modal-email');
              });
          
        },
        async relevante(data){
          let influencer = data.influencer;

          if (!influencer) {
            influencer = {
              nombre: data.canalTitulo || '',
              plataforma: 'youtube',
              plataformaUrl: data.canalUrl,
              email: '',
              emailEnviados: 0,
              fechaUltimoEmail: '',
              visible: 1
            };
          }
          else{
            influencer.visible = 1;
          }

          try {
            if (!influencer.id) {
              const response = await axios.post('/seo/influencers', influencer);
              //this.canalActual.influencer = response.data;
              this.$bvToast.toast('Relevante actualizado', {
                variant: 'success',
                solid: true
              });
            } else {
              await axios.post('/seo/influencers/update-relevante', {
                id: influencer.id,
                visible: influencer.visible
              });
              this.$bvToast.toast('Relevante actualizado', {
                variant: 'success',
                solid: true
              });
            }
          } catch (error) {
            console.error(error);
            this.$bvToast.toast('Error al guardar Relevante ', {
              variant: 'danger',
              solid: true
            });
          }

        },
        async noRelevante(data){
          let influencer = data.influencer;

          if (!influencer) {
            influencer = {
              nombre: data.canalTitulo || '',
              plataforma: 'youtube',
              plataformaUrl: data.canalUrl,
              email: '',
              emailEnviados: 0,
              fechaUltimoEmail: '',
              visible: 0
            };
          }
          else{
            influencer.visible = 0;
          }

          try {
            if (!influencer.id) {
              const response = await axios.post('/seo/influencers', influencer);
              //this.canalActual.influencer = response.data;
              this.$bvToast.toast('No relevante actualizado', {
                variant: 'success',
                solid: true
              });
            } else {
              await axios.post('/seo/influencers/update-relevante', {
                id: influencer.id,
                visible: influencer.visible
              });
              this.$bvToast.toast('No relevante actualizado', {
                variant: 'success',
                solid: true
              });
            }
          } catch (error) {
            console.error(error);
            this.$bvToast.toast('Error al guardar el No relevante ', {
              variant: 'danger',
              solid: true
            });
          }

        },
        getColorByDR(dr) {
          if (dr >= 90) {
            return '#28a745'; // Verde claro
          } else if (dr >= 70) {
            return '#ff9f00'; // Naranja
          } else {
            return '#dc3545'; // Rojo
          }
        },
        vincularEditor(resultado) {
          this.googleEnlaceAddEditor = resultado;
          this.$bvModal.show('modal-editor-agregar');
        },
        async estadoGoogleEnlace(item, estado){
          try {
            await axios.put('/seo/google/resultado/estado', {
              id: item.idResultado,
              estado: estado
            });

            item.estadoResultado = estado; // actualiza localmente

            const resultado = this.allGoogleResultados.find(r => r.id === item.id);
            if (resultado) {
              resultado.estadoResultado = estado;
            }
          } catch (error) {
            console.error('Error al actualizar el estado del resultado:', error);
          }
        },
        async estadoGoogleWeb(item, estado){

          try {
            await axios.put('/seo/google/web/estado', {
              id: item.idWeb,
              estado: estado
            });

            item.estadoWeb = estado; // actualiza localmente
            this.allGoogleResultados.forEach(r => {
              if (r.idWeb === item.idWeb) {
                r.estadoWeb = estado;
              }
            });
          } catch (error) {
            console.error('Error al actualizar el estado de la web:', error);
          }
        },
        debeMostrarGrupo(grupo, displayLink) {
            const estadoFiltro = this.filtroEstadoGoogle;

            // Resultados que coinciden con el estadoResultado
            const resultadosVisibles = grupo.filter(r =>
              estadoFiltro === 'Todos' ||
              (estadoFiltro === 'Revisar' && r.estadoResultado === 0) ||
              (estadoFiltro === 'Relevantes' && r.estadoResultado === 1) ||
              (estadoFiltro === 'No relevantes' && r.estadoResultado === 2)
            );

            // Estado de la web (asumimos que es el mismo para todo el grupo)
            const estadoWeb = grupo[0].estadoWeb;

            // Mostrar si hay al menos un resultado válido según estadoResultado,
            // o si la web es relevante para el filtro actual
            return (estadoWeb === 0 || estadoWeb === 1) && resultadosVisibles.length > 0 || estadoFiltro === 'Todos' ||
              (estadoFiltro === 'Revisar' && estadoWeb === 0) ||
              (estadoFiltro === 'Relevantes' && estadoWeb === 1) ||
              (estadoFiltro === 'No relevantes' && estadoWeb === 2);
        },
        selectEditor(editor) {
          if (!this.googleEnlaceAddEditor) {
            this.$bvToast.toast('No hay un enlace seleccionado para vincular.', {
              title: 'Error',
              variant: 'danger',
              solid: true,
            });
            return;
          }

            if (!Array.isArray(editor.url)) {
              editor.url = [];
            }
          editor.url.push(this.googleEnlaceAddEditor.idResultado);

          axios
            .put(`/seo/google/editores`, editor)
            .then(() => {
              this.$bvToast.toast('Editor vinculado con éxito.', {
          title: 'Éxito',
          variant: 'success',
          solid: true,
              });
              this.googleEnlaceAddEditor = null;
              this.$bvModal.hide('modal-editor-agregar');
            })
            .catch(error => {
              console.error('Error al vincular el editor:', error);
              this.$bvToast.toast('Error al vincular el editor.', {
          title: 'Error',
          variant: 'danger',
          solid: true,
              });
            });
        },
        addEditor() {
          if (!this.nuevoEditor.nombre || !this.nuevoEditor.email) {
            this.$bvToast.toast('Por favor, complete el nombre y el email del editor.', {
              title: 'Error',
              variant: 'danger',
              solid: true,
            });
            return;
          }

          let data = {
            ...this.nuevoEditor,
            categorias: this.nuevoEditor.categorias.join(', '),
            url: [],
          };

          data.url.push(this.googleEnlaceAddEditor.idResultado);

          axios
            .post('/seo/google/editores', data)
            .then(response => {
              data.id = response.data.insertId;
              this.listaEditores.push(data);
              this.$bvToast.toast('Editor agregado con éxito.', {
                title: 'Éxito',
                variant: 'success',
                solid: true,
              });
              this.$bvModal.hide('modal-editor-agregar');
                this.nuevoEditor = {
                  nombre: '',
                  email: '',
                  pais: '',
                  url: [],
                  fechaEncontrado: '',
                  emailEnviados: 0,
                  fechaUltimoEmail: '',
                  categorias: [],
                  observaciones: '',
                };
              })
              .catch(error => {
                    console.error('Error al agregar el editor:', error);
                    this.$bvToast.toast('Error al agregar el editor.', {
                      title: 'Error',
                      variant: 'danger',
                      solid: true,
                    });
              });
        },
        buscarEditoresArticulo(articulo){
        let numero = 0;

          let encontrados = this.listaEditores.filter(editor => {
            return editor.url.includes(articulo.idResultado);
          });

          if(encontrados.length > 0){
            numero = encontrados.length;
            return numero;
          }
          else{
            return '';
          }
          
        },
        async changeFav(data){

          let influencer = data.influencer;

          if (!influencer) {
            influencer = {
              nombre: data.canalTitulo || '',
              plataforma: 'youtube',
              plataformaUrl: data.canalUrl,
              email: '',
              emailEnviados: 0,
              fechaUltimoEmail: '',
              visible: 2,
              fav: 1
            };
          }else{
            if(influencer.fav == 1){
              influencer.fav = 0;
            }
            else
              influencer.fav = 1;
          }


          try {
            if (!influencer.id) {
              const response = await axios.post('/seo/influencers', influencer);
              //this.canalActual.influencer = response.data;
              this.$bvToast.toast('Favorito actualizado', {
                variant: 'success',
                solid: true
              });
            } else {
              await axios.post('/seo/influencers/update-fav', {
                id: influencer.id,
                fav: influencer.fav
              });
              this.$bvToast.toast('Favorito actualizado', {
                variant: 'success',
                solid: true
              });
            }
          } catch (error) {
            console.error(error);
            this.$bvToast.toast('Error al guardar favorito ', {
              variant: 'danger',
              solid: true
            });
          }
        },
        checkBotonRelevante(canal){
          if(canal.influencer && canal.influencer.visible == 1){
            return false;
          }
          else{
            return true;
          }
        },
        checkBotonNoRelevante(canal){
          if(canal.influencer && canal.influencer.visible == 0){
            return false;
          }
          else{
            return true;
          }
        },
        openCategoriasInfluencer(canal){
          this.canalActualCategoria = canal;
          if(canal.influencer && canal.influencer.categoria){
            this.categoriasInfluencerSelect = canal.influencer.categoria.replaceAll('"','').split(',');
          }
          else
            this.categoriasInfluencerSelect = [];
          this.$bvModal.show('modal-categoria');
        },     
        async guardarCategoriasInfluencer(){
          /*console.log(this.canalActualCategoria);
          console.log(this.categoriasInfluencerSelect);*/

          let influencer = this.canalActualCategoria.influencer;

          if (!influencer) {
            influencer = {
              nombre: this.canalActualCategoria.canalTitulo || '',
              plataforma: 'youtube',
              plataformaUrl: this.canalActualCategoria.canalUrl,
              email: '',
              emailEnviados: 0,
              fechaUltimoEmail: '',
              visible: 2,
              fav: 0,
              categoria: this.categoriasInfluencerSelect.join(',')
            };
          }else{
            influencer.categoria = this.categoriasInfluencerSelect.join(',');
          }

          try {
            if (!influencer.id) {
              const response = await axios.post('/seo/influencers', influencer);
              //this.canalActual.influencer = response.data;
              influencer.id = response.data.insertId;
              this.canalActualCategoria.influencer = influencer;
             
              this.$bvToast.toast('Categorias actualizado', {
                variant: 'success',
                solid: true
              });
            } else {
              await axios.post('/seo/influencers/update-categorias', {
                id: influencer.id,
                categorias: influencer.categorias
              });

              this.canalActualCategoria.influencer.categoria = influencer.categoria;
              //this.listadoInflucencersYoutube.find(canal => canal.canalUrl === influencer.plataformaUrl).influencer.categoria = influencer.categorias;
              
              this.$bvToast.toast('Categorias actualizado', {
                variant: 'success',
                solid: true
              });
            }
          } catch (error) {
            console.error(error);
            this.$bvToast.toast('Error al guardar categorias ', {
              variant: 'danger',
              solid: true
            });
          }
        },
        guardarFiltro(){

          let datos = {
            plataformaSeleccionada: this.plataformaSeleccionada,
            filtroEstado: this.filtroEstado,
            categoriaFiltroSeleccionada: this.categoriaFiltroSeleccionada,
            texto: this.texto,
            textoBusquedaGoogle: this.textoBusquedaGoogle,
            filtroEstadoGoogle: this.filtroEstadoGoogle,
            filtroDRGoogle: this.filtroDRGoogle,
            filtroYoutubeBusquedaTexto: this.filtroYoutubeBusquedaTexto,
            filtroGoogleBusquedaTexto: this.filtroGoogleBusquedaTexto
          }

          const date = new Date();
          const days = 30;
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          const expires = "expires=" + date.toUTCString();
          document.cookie = 'gestionInfluenceer' + "=" + JSON.stringify(datos) + ";" + expires + ";path=/";

        },
        cargarFiltro() {
          let datos = null;
          const nameEQ = 'gestionInfluenceer=';
          const cookiesArray = document.cookie.split(';');

          for (let i = 0; i < cookiesArray.length; i++) {
            let cookie = cookiesArray[i].trim();
            if (cookie.indexOf(nameEQ) === 0) {
              try {
                datos = JSON.parse(decodeURIComponent(cookie.substring(nameEQ.length)));
              } catch (e) {
                console.error('Error al parsear la cookie gestionInfluenceer:', e);
              }
            }
          }

          if (datos) {
            this.plataformaSeleccionada = datos.plataformaSeleccionada;
            this.filtroEstado = datos.filtroEstado;
            this.categoriaFiltroSeleccionada = datos.categoriaFiltroSeleccionada;
            this.texto = datos.texto;
            this.textoBusquedaGoogle = datos.textoBusquedaGoogle;
            this.filtroEstadoGoogle = datos.filtroEstadoGoogle;
            this.filtroDRGoogle = datos.filtroDRGoogle || "Todos";
            this.filtroYoutubeBusquedaTexto = datos.filtroYoutubeBusquedaTexto || '';
            this.filtroGoogleBusquedaTexto = datos.filtroGoogleBusquedaTexto || '';
          }
        }

      },
      mounted() {
        this.cargarFiltro();
        this.loadItems();
      },
      computed: {
        formartedItems () {
          return this.listaBusquedasYoutube.map(item => {
              const paisNombre = paises.find(p => p.code === item.pais)?.name || item.pais;
              const idiomaNombre = idiomas.find(i => i.code === item.idioma)?.name || item.idioma;
  
              return {
                ...item,
                paisNombre,
                idiomaNombre
              };
            })
        },
        resultadosFiltradosGoogle() {
          return this.allGoogleResultados.filter((resultado) => {
            // Filtro por texto
            /*const coincideTexto =
              this.textoBusquedaGoogle === '' ||
              (resultado.titulo && resultado.titulo.toLowerCase().includes(this.textoBusquedaGoogle.toLowerCase())) ||
              (resultado.descripcion && resultado.descripcion.toLowerCase().includes(this.textoBusquedaGoogle.toLowerCase())) ||
              (resultado.textoBusqueda && resultado.textoBusqueda.toLowerCase().includes(this.filtroGoogleBusquedaTexto.toLowerCase()));*/
            const filtroTituloDescripcion = (this.textoBusquedaGoogle || '').toLowerCase();
            const filtroTextoBusqueda = (this.filtroGoogleBusquedaTexto || '').toLowerCase();

            const coincideTexto =
              (filtroTituloDescripcion === '' || 
              (resultado.titulo && resultado.titulo.toLowerCase().includes(filtroTituloDescripcion)) ||
              (resultado.descripcion && resultado.descripcion.toLowerCase().includes(filtroTituloDescripcion)))
              &&
              (filtroTextoBusqueda === '' ||
              (resultado.textoBusqueda && resultado.textoBusqueda.toLowerCase().includes(filtroTextoBusqueda)));

            // Filtro por estado resultado
            const coincideEstado =
              this.filtroEstadoGoogle === 'Todos' ||
              (this.filtroEstadoGoogle === 'Revisar' && resultado.estadoResultado === 0) ||
              (this.filtroEstadoGoogle === 'Relevantes' && resultado.estadoResultado === 1) ||
              (this.filtroEstadoGoogle === 'No relevantes' && resultado.estadoResultado === 2);

               // Filtro por estado web
            const coincideEstadoWeb =
              this.filtroEstadoGoogle === 'Todos' || 
              (this.filtroEstadoGoogle === 'Revisar' && resultado.estadoWeb === 0) ||
              (this.filtroEstadoGoogle === 'Relevantes' && resultado.estadoWeb === 1) ||
              (this.filtroEstadoGoogle === 'No relevantes' && resultado.estadoWeb === 2);

            /*const coincideDRWeb = resultado.dr >= 0;
              filtroDRGoogle*/

            const coincideDRWeb =
              this.filtroDRGoogle === 'Todos' || this.filtroDRGoogle === '' ||
              (this.filtroDRGoogle === '90 >' && resultado.dr >= 90) ||
              (this.filtroDRGoogle === '75 - 89' && resultado.dr >= 75 && resultado.dr <= 89) ||
              (this.filtroDRGoogle === '50 - 74' && resultado.dr >= 50 && resultado.dr <= 74) ||
              (this.filtroDRGoogle === '< 49' && resultado.dr <= 49);


            return coincideTexto && (coincideEstado || coincideEstadoWeb) && coincideDRWeb;
          });
        },   
        listadoFiltrado() {
          let filtrado = this.listadoInflucencersYoutube;

          if (this.texto) {
            const filtro = this.texto.toLowerCase();
            filtrado = filtrado.filter(canal =>
              canal.canalTitulo.toLowerCase().includes(filtro)
            );
          }

          if (this.filtroYoutubeBusquedaTexto) {
              const filtroYT = this.filtroYoutubeBusquedaTexto.toLowerCase();
              filtrado = filtrado.filter(canal =>
                canal.videos &&
                canal.videos.some(video =>
                  video.youtubeBusqueda &&
                  video.youtubeBusqueda.texto &&
                  video.youtubeBusqueda.texto.toLowerCase().includes(filtroYT)
                )
              );
            }


          if (this.filtroEstado === 'Revisar') {
            filtrado = filtrado.filter(canal => !canal.influencer || canal.influencer.visible === 2);
          } else if (this.filtroEstado === 'Contactados') {
            filtrado = filtrado.filter(canal => canal.influencer && canal.influencer.emailEnviados > 0);
          } else if (this.filtroEstado === 'Relevantes sin contactar') {
            filtrado = filtrado.filter(canal => canal.influencer && canal.influencer.visible === 1 && canal.influencer.emailEnviados === 0  && canal.influencer.email != "");
          } else if (this.filtroEstado === 'Relevantes, agregar email') {
            filtrado = filtrado.filter(canal => canal.influencer && canal.influencer.visible === 1 && !canal.influencer.email);
          } else if (this.filtroEstado === 'Favoritos') {
            filtrado = filtrado.filter(canal => canal.influencer && canal.influencer.fav === 1);
          } else if (this.filtroEstado === 'No Relevantes') {
            filtrado = filtrado.filter(canal => canal.influencer && canal.influencer.visible === 0);
          }

          if (this.categoriaFiltroSeleccionada && this.categoriaFiltroSeleccionada !== 'Todas') {
            const categoria = this.categoriaFiltroSeleccionada.toLowerCase();
            filtrado = filtrado.filter(canal =>
              canal.influencer &&
              canal.influencer.categoria &&
              canal.influencer.categoria.toLowerCase().includes(categoria)
            );
          }

          return filtrado;
        }

      },
      watch: {
        plataformaSeleccionada() {
          this.guardarFiltro();
        },
        filtroEstado() {
          this.guardarFiltro();
        },
        categoriaFiltroSeleccionada() {
          this.guardarFiltro();
        },
        texto() {
          this.guardarFiltro();
        },
        textoBusquedaGoogle() {
          this.guardarFiltro();
        },
        filtroEstadoGoogle() {
          this.guardarFiltro();
        },
        filtroDRGoogle(){
          this.guardarFiltro();
        }
      }
    }
</script>

<style lang="scss">
    @import '../@core/scss/vue/libs/vue-select.scss';
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap');

    .btn-span:hover{
        cursor: pointer;
    }

    .btn-span{
        color: rgb(212, 89, 89);
    }
    .icon-brand{
        font-size: 100px;
    }
    .icon-click:hover{
        cursor: pointer;
    }
    .icon-noclick{
        cursor:  not-allowed;
    }

    // ══════════════════════════════════════════════════════════════
    // DATA-DENSE DASHBOARD — GESTIÓN INFLUENCERS
    // Same tokens as /pedido-taller-vero/fabricando
    // ══════════════════════════════════════════════════════════════

    $gi-bg:        #F8FAFC;
    $gi-surface:   #FFFFFF;
    $gi-surface-2: #F1F5F9;
    $gi-border:    #E2E8F0;
    $gi-divider:   #EEF2F7;
    $gi-ink:       #1E293B;
    $gi-text:      #1E293B;
    $gi-mute:      #64748B;
    $gi-soft:      #94A3B8;
    $gi-primary:   #3B82F6;
    $gi-primary-soft: #60A5FA;
    $gi-cta:       #F97316;
    $gi-emerald:   #10B981;
    $gi-coral:     #EF4444;
    $gi-amber:     #F59E0B;
    $gi-yellow:    #FACC15;

    .gi {
      font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
      background: $gi-bg;
      color: $gi-text;
      margin: -2rem;
      padding: 28px 32px 56px;
      min-height: calc(100vh - 4rem);
      font-feature-settings: "tnum", "zero";

      *, *::before, *::after { box-sizing: border-box; }

      // ──────────── HEADER CARD ────────────
      .gi-dash-header {
        background: $gi-surface;
        border: 1px solid $gi-border;
        border-radius: 14px;
        padding: 18px 20px 14px;
        margin-bottom: 18px;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
      }

      .gi-dash-header-top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 16px;
        margin-bottom: 16px;
        flex-wrap: wrap;
      }

      .gi-eyebrow {
        font-family: 'JetBrains Mono', monospace;
        font-size: 10px;
        font-weight: 600;
        color: $gi-primary;
        letter-spacing: 0.14em;
        margin-bottom: 4px;

        &::before {
          content: '';
          display: inline-block;
          width: 6px;
          height: 6px;
          background: $gi-cta;
          border-radius: 50%;
          margin-right: 6px;
          vertical-align: middle;
          animation: gi-pulse 2s infinite;
        }
      }

      .gi-title {
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 22px;
        font-weight: 700;
        color: $gi-ink;
        line-height: 1.1;
        letter-spacing: -0.01em;
        margin: 0;
      }

      .gi-header-actions {
        display: flex;
        gap: 8px;
        align-items: center;
      }

      .gi-stat-pill {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        height: 38px;
        padding: 0 14px;
        background: $gi-bg;
        border: 1px solid $gi-border;
        border-radius: 8px;
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 12px;
        font-weight: 500;
        color: $gi-mute;

        i { color: $gi-primary; font-size: 13px; }
        strong {
          font-family: 'JetBrains Mono', monospace;
          font-size: 13px;
          font-weight: 700;
          color: $gi-ink;
          font-feature-settings: "tnum";
        }
      }

      // ──────────── PLATFORM TABS ────────────
      .gi-platforms {
        display: flex;
        gap: 6px;
        background: $gi-bg;
        border: 1px solid $gi-border;
        border-radius: 10px;
        padding: 4px;
      }

      .gi-platform {
        flex: 1;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        height: 42px;
        padding: 0 16px;
        background: transparent;
        border: 1px solid transparent;
        border-radius: 8px;
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 13px;
        font-weight: 600;
        color: $gi-mute;
        cursor: pointer;
        transition: all 200ms ease;
        position: relative;

        i { font-size: 16px; color: $gi-soft; }
        span { display: inline-block; }

        &:hover:not(.is-disabled) {
          color: $gi-ink;
          background: rgba(15, 23, 42, 0.03);
          i { color: $gi-mute; }
        }

        &.is-active {
          background: $gi-surface;
          color: $gi-ink;
          border-color: $gi-border;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
        }

        &.is-disabled {
          cursor: not-allowed;
          opacity: 0.4;
        }
      }

      .gi-platform-soon {
        font-family: 'JetBrains Mono', monospace;
        font-size: 9px;
        font-weight: 700;
        letter-spacing: 0.12em;
        background: rgba(15, 23, 42, 0.08);
        color: $gi-mute;
        padding: 2px 6px;
        border-radius: 4px;
      }

      // ──────────── B-CARD-CODE / B-CARD overrides ────────────
      .card,
      .b-card-code {
        background: $gi-surface !important;
        border: 1px solid $gi-border !important;
        border-radius: 14px !important;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;

        .card-header {
          background: $gi-surface !important;
          border-bottom: 1px solid $gi-divider !important;
          padding: 14px 20px !important;
        }
        .card-title { color: $gi-ink !important; font-weight: 700 !important; font-size: 15px; }
        .card-body { padding: 18px 20px !important; }
      }

      // ──────────── FORM CONTROLS ────────────
      .form-group label,
      legend {
        font-family: 'JetBrains Mono', monospace !important;
        font-size: 10px !important;
        font-weight: 600 !important;
        color: $gi-soft !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
        margin-bottom: 6px !important;
      }

      .form-control {
        background: $gi-surface !important;
        border: 1px solid $gi-border !important;
        border-radius: 8px !important;
        font-size: 13px !important;
        height: 38px !important;
        color: $gi-ink !important;
        transition: all 150ms ease !important;
        box-shadow: none !important;

        &::placeholder { color: $gi-soft; }
        &:focus {
          outline: none !important;
          border-color: $gi-primary !important;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12) !important;
        }
      }

      // ──────────── V-SELECT ────────────
      .v-select {
        .vs__dropdown-toggle {
          background: $gi-surface !important;
          border: 1px solid $gi-border !important;
          border-radius: 8px !important;
          min-height: 38px;
          padding: 0 6px;
        }
        &.vs--open .vs__dropdown-toggle,
        .vs__dropdown-toggle:focus-within {
          border-color: $gi-primary !important;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12) !important;
        }
        .vs__selected, .vs__search {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13px;
          color: $gi-ink;
          padding: 0 6px;
          line-height: 36px;
        }
        .vs__open-indicator { fill: $gi-soft; transform: scale(0.75); }
        .vs__dropdown-menu {
          background: $gi-surface;
          border: 1px solid $gi-border;
          border-radius: 8px;
          box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
          padding: 4px;
        }
        .vs__dropdown-option {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13px;
          color: $gi-text;
          padding: 8px 10px;
          border-radius: 6px;
          &--highlight { background: $gi-surface-2; color: $gi-primary; }
        }
      }

      // ──────────── BUTTONS ────────────
      .btn {
        font-family: 'Plus Jakarta Sans', sans-serif !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border-radius: 8px !important;
        padding: 8px 14px !important;
        transition: all 200ms ease !important;
        box-shadow: none !important;
        border-width: 1px !important;
        display: inline-flex;
        align-items: center;
        gap: 6px;

        &.btn-sm { padding: 6px 10px !important; font-size: 11px !important; }

        &.btn-primary {
          background: $gi-primary !important;
          border-color: $gi-primary !important;
          color: #fff !important;
          &:hover:not(:disabled) {
            background: darken($gi-primary, 6%) !important;
            border-color: darken($gi-primary, 6%) !important;
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25) !important;
          }
        }
        &.btn-success {
          background: $gi-emerald !important;
          border-color: $gi-emerald !important;
          color: #fff !important;
          &:hover:not(:disabled) { background: darken($gi-emerald, 6%) !important; border-color: darken($gi-emerald, 6%) !important; }
        }
        &.btn-danger {
          background: $gi-coral !important;
          border-color: $gi-coral !important;
          color: #fff !important;
          &:hover:not(:disabled) { background: darken($gi-coral, 6%) !important; border-color: darken($gi-coral, 6%) !important; }
        }
        &.btn-warning {
          background: $gi-cta !important;
          border-color: $gi-cta !important;
          color: #fff !important;
          &:hover:not(:disabled) { background: darken($gi-cta, 6%) !important; border-color: darken($gi-cta, 6%) !important; }
        }
        &.btn-link {
          background: transparent !important;
          border: 0 !important;
          color: $gi-primary !important;
          &:hover { color: darken($gi-primary, 10%) !important; text-decoration: underline; }
        }
      }

      // ──────────── CHANNEL / GRUPO CARDS ────────────
      // Override b-card inside the grid
      .container-fluid > .row > .col-md-4 .card {
        border: 1px solid $gi-border !important;
        border-radius: 12px !important;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
        transition: all 200ms ease;

        &:hover {
          border-color: $gi-primary-soft !important;
          box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06) !important;
          transform: translateY(-1px);
        }

        h5 {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 14px;
          font-weight: 700;
          color: $gi-ink;
          margin: 0 0 4px;
          letter-spacing: -0.01em;

          a { color: $gi-ink; text-decoration: none; }
          a:hover { color: $gi-primary; }
        }

        h6 {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13px;
          font-weight: 600;
          color: $gi-ink;
          margin-bottom: 4px;

          a { color: $gi-ink; text-decoration: none; }
          a:hover { color: $gi-primary; }
        }

        small, .text-muted {
          font-size: 11px !important;
          color: $gi-mute !important;
          line-height: 1.5;
        }

        .img-thumbnail {
          border: 1px solid $gi-border !important;
          border-radius: 6px !important;
          padding: 0 !important;
          background: $gi-surface-2;
        }
      }

      // ──────────── B-TABLE ────────────
      .table {
        background: $gi-surface !important;
        margin-bottom: 0;

        thead th {
          font-family: 'JetBrains Mono', monospace !important;
          font-size: 10px !important;
          font-weight: 600 !important;
          color: $gi-soft !important;
          letter-spacing: 0.08em !important;
          text-transform: uppercase;
          background: $gi-surface !important;
          border-bottom: 1px solid $gi-border !important;
          border-top: 0 !important;
          padding: 13px 14px !important;
        }
        tbody tr {
          transition: background 150ms ease;
          td {
            border-top: 1px solid $gi-divider !important;
            font-size: 13px;
            color: $gi-text !important;
            padding: 11px 14px !important;
            vertical-align: middle;
          }
          &:hover { background: rgba(59, 130, 246, 0.04) !important; }
        }
      }

      // ──────────── HEADINGS ────────────
      h3 {
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 16px;
        font-weight: 700;
        color: $gi-ink;
        letter-spacing: -0.01em;
        margin: 8px 0 14px;

        span {
          font-family: 'JetBrains Mono', monospace;
          font-size: 13px;
          color: $gi-primary;
          font-weight: 700;
          background: rgba(59, 130, 246, 0.08);
          padding: 2px 8px;
          border-radius: 6px;
          margin-left: 4px;
        }
      }

      // ──────────── ICONS ────────────
      .fav-check { color: $gi-yellow !important; }
      .fav-btn { cursor: pointer; }

      .cat-btn {
        background: $gi-surface-2 !important;
        color: $gi-mute !important;
        padding: 4px 7px !important;
        border-radius: 6px !important;
        font-size: 11px;
        margin-right: 4px;

        &:hover { background: rgba(59, 130, 246, 0.12) !important; color: $gi-primary !important; }
      }

      // ──────────── HIDE OLD PLATFORM ICONS ROW ────────────
      .icon-brand { display: none !important; }

      // ══════════════════════════════════════════════════════════════
      // CHANNEL CARDS (YouTube grid)
      // ══════════════════════════════════════════════════════════════

      .gi-yt-wrap { padding: 0; }

      .gi-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
        gap: 16px;

        @media (max-width: 1280px) {
          grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
        }
      }

      .gi-channel {
        background: $gi-surface;
        border: 1px solid $gi-border;
        border-radius: 14px;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
        padding: 16px 16px 14px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        transition: all 200ms ease;

        &:hover {
          border-color: $gi-primary-soft;
          box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
          transform: translateY(-1px);
        }
      }

      // ──── HEAD ────
      .gi-ch-head {
        display: flex;
        align-items: flex-start;
        gap: 12px;
      }

      .gi-ch-avatar-wrap {
        flex-shrink: 0;
        position: relative;
        display: block;
      }

      .gi-ch-avatar {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        object-fit: cover;
        border: 1px solid $gi-border;
        background: $gi-surface-2;
        display: block;
      }

      .gi-ch-info {
        flex: 1;
        min-width: 0;
      }

      .gi-ch-name-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 4px;
      }

      .gi-ch-name {
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 14px;
        font-weight: 700;
        color: $gi-ink;
        text-decoration: none;
        line-height: 1.25;
        letter-spacing: -0.01em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        min-width: 0;

        &:hover { color: $gi-primary; }
      }

      .gi-ch-fav {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        border: 0;
        background: transparent;
        color: $gi-soft;
        font-size: 12px;
        cursor: pointer;
        border-radius: 6px;
        transition: all 150ms ease;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        &:hover { background: $gi-surface-2; color: $gi-yellow; }
        &.is-fav { color: $gi-yellow; }
      }

      .gi-ch-meta {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        flex-wrap: wrap;
        font-size: 11px;
        color: $gi-mute;
      }

      .gi-ch-meta-item {
        display: inline-flex;
        align-items: center;
        gap: 4px;

        i { font-size: 9px; color: $gi-soft; }
      }

      .gi-ch-meta-strong {
        font-family: 'JetBrains Mono', monospace;
        font-weight: 700;
        color: $gi-ink;
        font-feature-settings: "tnum";
      }

      .gi-ch-meta-sep {
        color: $gi-soft;
        opacity: 0.5;
      }

      .gi-ch-action {
        flex-shrink: 0;
      }

      // ──── BUTTONS ────
      .gi-ch-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        height: 32px;
        padding: 0 12px;
        border-radius: 8px;
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 11px;
        font-weight: 600;
        cursor: pointer;
        transition: all 200ms ease;
        border: 1px solid transparent;
        white-space: nowrap;

        i { font-size: 11px; }

        &--primary {
          background: $gi-primary;
          color: #fff;
          &:hover { background: darken($gi-primary, 6%); box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25); }
        }
        &--warn {
          background: $gi-cta;
          color: #fff;
          &:hover { background: darken($gi-cta, 6%); box-shadow: 0 4px 12px rgba(249, 115, 22, 0.25); }
        }
        &--success {
          background: $gi-emerald;
          color: #fff;
          flex: 1;
          &:hover { background: darken($gi-emerald, 6%); box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25); }
        }
        &--ghost-danger {
          background: transparent;
          color: $gi-coral;
          border-color: $gi-border;
          flex: 1;
          &:hover { background: rgba(239, 68, 68, 0.06); border-color: $gi-coral; }
        }
      }

      // ──── TAGS / PILLS ────
      .gi-ch-tags {
        display: flex;
        align-items: center;
        gap: 6px;
        flex-wrap: wrap;
      }

      .gi-ch-cat-btn {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        height: 24px;
        padding: 0 9px;
        background: $gi-surface-2;
        border: 1px solid $gi-border;
        border-radius: 6px;
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 10px;
        font-weight: 600;
        color: $gi-text;
        cursor: pointer;
        transition: all 150ms ease;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        i { font-size: 9px; color: $gi-mute; }
        span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &:hover {
          background: rgba(59, 130, 246, 0.08);
          border-color: $gi-primary-soft;
          color: $gi-primary;
          i { color: $gi-primary; }
        }
      }

      .gi-ch-cat-empty {
        font-style: italic;
        color: $gi-soft;
        font-weight: 500;
      }

      .gi-ch-pill {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        height: 22px;
        padding: 0 8px;
        border-radius: 999px;
        font-family: 'JetBrains Mono', monospace;
        font-size: 9.5px;
        font-weight: 700;
        letter-spacing: 0.04em;

        i { font-size: 9px; }

        &--match {
          background: rgba(59, 130, 246, 0.1);
          color: $gi-primary;
        }
        &--contacted {
          background: rgba(16, 185, 129, 0.1);
          color: $gi-emerald;
        }
      }

      // ──── VIDEOS ────
      .gi-ch-videos {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: 10px;
        border-top: 1px solid $gi-divider;
        padding-top: 12px;
      }

      .gi-ch-video {
        display: flex;
        gap: 10px;
        align-items: flex-start;
      }

      .gi-ch-video-thumb {
        position: relative;
        flex-shrink: 0;
        width: 92px;
        height: 52px;
        border-radius: 6px;
        overflow: hidden;
        background: $gi-surface-2;
        display: block;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform 250ms ease;
        }

        .gi-ch-video-play {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) scale(0.8);
          width: 26px;
          height: 26px;
          border-radius: 50%;
          background: rgba(0, 0, 0, 0.6);
          color: #fff;
          font-size: 9px;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: all 200ms ease;
          padding-left: 2px;
        }

        &:hover {
          img { transform: scale(1.05); }
          .gi-ch-video-play { opacity: 1; transform: translate(-50%, -50%) scale(1); }
        }
      }

      .gi-ch-video-body {
        flex: 1;
        min-width: 0;
      }

      .gi-ch-video-title {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 12px;
        font-weight: 600;
        color: $gi-ink;
        line-height: 1.35;
        text-decoration: none;
        margin-bottom: 4px;

        &:hover { color: $gi-primary; }
      }

      .gi-ch-video-stats {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        font-family: 'JetBrains Mono', monospace;
        font-size: 10px;
        color: $gi-mute;
        margin-bottom: 4px;
        font-feature-settings: "tnum";

        i { font-size: 8px; opacity: 0.7; }
      }

      .gi-ch-video-search {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        flex-wrap: wrap;
      }

      .gi-ch-tag {
        display: inline-block;
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 9.5px;
        font-weight: 600;
        color: $gi-mute;
        background: $gi-surface-2;
        padding: 2px 7px;
        border-radius: 4px;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &--mini {
          background: rgba(59, 130, 246, 0.08);
          color: $gi-primary;
          font-weight: 700;
          letter-spacing: 0.02em;
          text-transform: uppercase;
          font-size: 9px;
        }
      }

      // ──── MORE TOGGLE ────
      .gi-ch-more {
        align-self: flex-start;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: transparent;
        border: 0;
        color: $gi-primary;
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 11px;
        font-weight: 600;
        padding: 4px 0 0;
        cursor: pointer;
        transition: color 150ms ease;

        i { font-size: 9px; }

        &:hover { color: darken($gi-primary, 10%); text-decoration: underline; }
      }

      // ──── FOOTER ACTIONS ────
      .gi-ch-foot {
        display: flex;
        gap: 8px;
        padding-top: 12px;
        border-top: 1px solid $gi-divider;
      }

      // ──────────── ANIMATIONS ────────────
      @keyframes gi-pulse {
        0%, 100% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.55; transform: scale(0.85); }
      }

      @media (prefers-reduced-motion: reduce) {
        *, *::before, *::after {
          animation-duration: 0.01ms !important;
          transition-duration: 0.01ms !important;
        }
      }
    }

    // ══════════ DARK MODE ══════════
    .dark-layout .gi {
      background: #161616;
      color: #d0d2d6;

      .gi-dash-header,
      .card, .b-card-code { background: #1f1f1f !important; border-color: #2c2c2c !important; }
      .gi-title { color: #e4e6eb; }
      .gi-stat-pill { background: #161616; border-color: #2c2c2c; }
      .gi-stat-pill strong { color: #e4e6eb; }

      .gi-platforms { background: #161616; border-color: #2c2c2c; }
      .gi-platform { color: #8e9099; }
      .gi-platform.is-active { background: #242424; border-color: #2c2c2c; color: #e4e6eb; }

      .form-control {
        background: #1f1f1f !important;
        border-color: #2c2c2c !important;
        color: #d0d2d6 !important;
        &:focus { background: #242424 !important; }
      }

      .v-select .vs__dropdown-toggle { background: #1f1f1f !important; border-color: #2c2c2c !important; }
      .v-select .vs__selected, .v-select .vs__search { color: #d0d2d6; }
      .v-select .vs__dropdown-menu { background: #242424; border-color: #3a3a3a; }
      .v-select .vs__dropdown-option { color: #d0d2d6; }
      .v-select .vs__dropdown-option--highlight { background: #2c2c2c; color: #fff; }

      .table thead th { background: #1f1f1f !important; color: #6e7079 !important; border-bottom-color: #2c2c2c !important; }
      .table tbody tr td { border-top-color: #2c2c2c !important; color: #d0d2d6 !important; }
      .table tbody tr:hover { background: rgba(59, 130, 246, 0.08) !important; }

      h3 { color: #e4e6eb; }

      // Cabecera de las b-card-code y tabs de plataforma
      .card .card-header { background: #1f1f1f !important; border-bottom-color: #2c2c2c !important; }
      .card .card-title { color: #e4e6eb !important; }
      .gi-platform:hover:not(.is-disabled) { background: #242424; color: #e4e6eb; }
      .gi-platform-soon { background: #2c2c2c; color: #8e9099; }

      .table { background: #1f1f1f !important; }

      // Tarjetas de Google (webs / editores)
      .container-fluid > .row > .col-md-4 .card { border-color: #2c2c2c !important; }
      .container-fluid > .row > .col-md-4 .card {
        h5, h6, h5 a, h6 a { color: #e4e6eb; }
        small, .text-muted { color: #8e9099 !important; }
        .img-thumbnail { background: #242424; border-color: #2c2c2c !important; }
      }
      .cat-btn { background: #242424 !important; color: #b4b7bd !important; }
      .cat-btn:hover { background: rgba(59, 130, 246, 0.12) !important; color: #3B82F6 !important; }

      // Tarjetas de canales YouTube (el fondo verde inline por emails enviados se anula; el pill "contactado" ya lo indica)
      .gi-channel { background-color: #1f1f1f !important; border-color: #2c2c2c; }
      .gi-channel:hover { border-color: #60A5FA; }
      .gi-ch-avatar { background: #242424; border-color: #2c2c2c; }
      .gi-ch-name { color: #e4e6eb; }
      .gi-ch-fav:hover { background: #242424; }
      .gi-ch-meta { color: #8e9099; }
      .gi-ch-meta-strong { color: #e4e6eb; }
      .gi-ch-btn--ghost-danger { border-color: #2c2c2c; &:hover { border-color: #EF4444; } }
      .gi-ch-cat-btn { background: #242424; border-color: #2c2c2c; color: #d0d2d6; }
      .gi-ch-cat-btn:hover { background: rgba(59, 130, 246, 0.08); border-color: #60A5FA; color: #3B82F6; }
      .gi-ch-videos, .gi-ch-foot { border-top-color: #2c2c2c; }
      .gi-ch-video-thumb { background: #242424; }
      .gi-ch-video-title { color: #e4e6eb; }
      .gi-ch-video-stats { color: #8e9099; }
      .gi-ch-tag { background: #242424; color: #b4b7bd; }
      .gi-ch-tag--mini { background: rgba(59, 130, 246, 0.08); color: #3B82F6; }
    }
</style>

<style scoped>
  .video-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 16px;
  }
  .video-card {
    border: 1px solid #ddd;
    padding: 12px;
    border-radius: 8px;
    background: #fff;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
  }
  .thumbnail {
    width: 100%;
    border-radius: 8px;
  }
  .video-info {
    margin-top: 10px;
  }
  .video-info h3 {
    font-size: 16px;
  }
  .video-info p {
    font-size: 14px;
    margin: 4px 0;
  }
</style>

<style scoped>
a {
  text-decoration: none;
  color: #007bff;
}

.small-video {
  border-bottom: 1px solid #eee;
  padding-bottom: 0.5rem;
}

.btn-font-circle{
  border-radius: 50%;
  background-color: #526cff;
  color: white;
  padding: 5px;
}

.btn-font-circle:hover{
  background-color: #3b52e6;
  cursor: pointer;
}

.span-btn:hover{
  cursor: pointer;
}
.fav-btn:hover{
  cursor: pointer;
}

.fav-check{
  color: #ffd900;
}

.cat-btn{
  background-color: #f0f0f0;
  color: #333;
  padding: 5px;
  border-radius: 5px;
}
.cat-btn:hover{
  background-color: #e0e0e0;
  cursor: pointer;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
</style>
